import { render, staticRenderFns } from "./ResultEntryWidget.vue?vue&type=template&id=aa37042c&scoped=true&lang=html&"
import script from "./ResultEntryWidget.vue?vue&type=script&lang=js&"
export * from "./ResultEntryWidget.vue?vue&type=script&lang=js&"
import style0 from "./ResultEntryWidget.vue?vue&type=style&index=0&id=aa37042c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa37042c",
  null
  
)

export default component.exports